import { graphql } from '@/generated/gql';

export const PROCUREMENT_KNOWLEDGE_DETAILS_QUERY = graphql(/* GraphQL */ `
  query ProcurementKnowledgeDocumentDetails($docId: UUID!) {
    sevenbridges {
      document(id: $docId) {
        id
        fileId
        title
        description
        variant
        language
        url
        content
      }
    }
  }
`);
